module finadai.app.admin.change_sic {
    import ProxyRecord = models.http.responses.ProxyRecord;
    export var NAME = "finadai.app.admin.change_sic"

    function AdminChangeSICController(customersService: services.CustomersService,
                                      whoIAm: models.User, $rootScope, $scope,
                                      notify, confirm, $mdDialog: ng.material.IDialogService,
                                      $state: ng.ui.IStateService, negotiationsService: services.NegotiationsService,
                                      proxifier, $q: ng.IQService, authService: services.AuthService) {

        $scope.formData = {};
        $scope.canChangeSIC = whoIAm.operations.indexOf('admin_change_sic_customer') >= 0;
        $scope.searchingCreditsCustomer = false;
        $scope.showCreditCustomersForm = false;
        $scope.changingSICCredits = false;
        $scope.searchCreditCustomerData = {};
        $scope.creditsCustomers = {};
        $scope.creditsCustomersData = {};
        $scope.creditsCustomersData.credits_sic = [];

        $scope.changeMotive = function (credit) {
        };

        $scope.reviewIfChecked = function (credit) {
            return credit.EstatusSIC == 1;
        };

        $scope.toogleChange = function (credit) {
            if (credit.EstatusSIC == 1) {
                credit.EstatusSIC = 0;
            } else {
                credit.EstatusSIC = 1;
            }
        };

        $scope.searchCustomersCredits = (form) => {
            $scope.showCreditCustomersForm = false;
            $scope.searchingCreditsCustomer = true;
            if (form.$valid) {
                customersService.proxySearchCredit({
                    customer_number: $scope.searchCreditCustomerData.customer_number
                })
                    .then(function (response) {
                        console.log(response.data);
                        $scope.creditsCustomers = response.data;
                        $scope.creditsCustomers = angular.isArray($scope.creditsCustomers.Data.Saldo) ? $scope.creditsCustomers.Data.Saldo : [$scope.creditsCustomers.Data.Saldo];
                        $scope.searchingCreditsCustomer = false;
                        $scope.showCreditCustomersForm = true;
                    }, function () {
                        $scope.searchingCreditsCustomer = false;
                    });
            } else {
                $scope.searchingCreditsCustomer = false;
            }
        };

        $scope.changeSICCredits = (form) => {
            $scope.changingSICCredits = true;
            $scope.searchingCreditsCustomer = true;
            customersService.proxyChangeSICCustomerAdmin({
                credits: $scope.creditsCustomers
            })
                .then(function (response) {
                    notify('Datos Actualizados con Exito');
                    $scope.searchingCreditsCustomer = false;
                    $scope.showCreditCustomersForm = false;
                    $scope.searchCreditCustomerData.customer_number = 0;
                });
            $scope.changingSICCredits = false;
        };
    }

    export function run() {
        var find = angular.module(NAME, [])
        find.controller("AdminChangeSICController", AdminChangeSICController)
    }
}
finadai.app.admin.change_sic.run();
